export default  angular.module('ApiUtils.khutils.ui', []);

